import { render, staticRenderFns } from "./regionForm.vue?vue&type=template&id=1ac9721a"
import script from "./regionForm.vue?vue&type=script&lang=js"
export * from "./regionForm.vue?vue&type=script&lang=js"
import style0 from "./regionForm.vue?vue&type=style&index=0&id=1ac9721a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports